import { useCallback, useState } from 'react';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import FormattedMessage from 'I18n/components/FormattedMessage';
import QuotesLogger from 'quotes-ui-lib/tracking/quotesLogger';
import { getQuoteProperty } from 'quotes-ui-lib/utils/quote';
import { getOpenSigningPageErrorAlert, isUserOutstandingSigner } from '../utils/esign';
import { fetchCountersignerDetails } from '../api/QuotesApi';
import { getQuoteSigningUrl } from '../utils/urls';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import { getIsArchived, getIsPublished } from '../utils/status';
import { jsx as _jsx } from "react/jsx-runtime";
const CountersignButton = ({
  quote,
  trackingLocation,
  buttonRef,
  onLoadingFinish
}) => {
  const publicUrlKey = getQuoteProperty(quote, 'hs_public_url_key');
  const [isFetching, setIsFetching] = useState(false);
  const [isFetchingFailed, setIsFetchingFailed] = useState(false);
  const handleButtonClick = useCallback(() => {
    QuotesLogger.log('quoteInteraction', {
      action: 'Countersign quote',
      location: trackingLocation
    });
    setIsFetchingFailed(false);
    setIsFetching(true);
    fetchCountersignerDetails(publicUrlKey).then(({
      signatureId,
      signatureToken
    }) => {
      const quoteSigningUrl = getQuoteSigningUrl(quote, {
        signatureId,
        signatureToken
      });
      window.open(quoteSigningUrl, '_blank');
    }).catch(error => {
      setIsFetchingFailed(true);
      FloatingAlertStore.addAlert(getOpenSigningPageErrorAlert(error));
    }).finally(() => {
      setIsFetching(false);
    });
  }, [publicUrlKey, quote, trackingLocation]);
  return (
    /*#__PURE__*/
    // Migrate when fixed: https://git.hubteam.com/HubSpot/foundations-components/issues/5923
    _jsx(UILoadingButton, {
      "data-test-id": "countersign-button",
      use: "tertiary-light",
      responsive: false,
      onClick: handleButtonClick,
      buttonRef: buttonRef,
      loading: isFetching,
      onLoadingFinish: onLoadingFinish,
      failed: isFetchingFailed,
      disabled: isFetching,
      spinnerProps: {
        'data-test-id': 'countersign-button-spinner'
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "quotesUiLib.countersignButton.text"
      })
    })
  );
};
export function shouldShowCountersignButton(quote, userEmail, quoteSigners) {
  return Boolean(quoteSigners && isUserOutstandingSigner(userEmail, quoteSigners) && !getIsArchived(quote) && getIsPublished(quote));
}
export default CountersignButton;